import "tslib";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import configureStore from "@store/configureStore";
import LanguageProvider from "@intl/LanguageProvider";
import * as serviceWorker from "./serviceWorker";
import { createHashHistory } from "history";
import { Provider, ReactReduxContext } from "react-redux";
import "./styles/index.scss";
import {fetchCurrentUserRequest} from "@actions/user";
import {loginSuccess} from './actions/auth';

export const history = createHashHistory({
  // basename: '',
  // hashType: 'slash' //Hugh does not work!
});

const initialState = window.initialReduxState;
const store = configureStore(history, initialState);


//Read Data From Local Storage
const user = JSON.parse(localStorage.getItem('user'));
if (user && user.access_token) {
  store.dispatch(loginSuccess(JSON.parse(localStorage.getItem("user"))));
  store.dispatch(fetchCurrentUserRequest());
}


ReactDOM.render(
  <LanguageProvider>
            <Provider store={store} context={ReactReduxContext}>
                <App/>
            </Provider>
            </LanguageProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
